// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"105ff253","537":"0717a83a","554":"a57abebb","663":"7aea8020","824":"b1028ea2","943":"2d10f9f3"}[chunkId] + ".chunk.js";
};